import { $Q } from '../utils/query-selector'

/**
 * Controls the visibility of the header logo based on its overlap with the footer logo.
 * - On mobile: Adjusts visibility based on overlap.
 * - On desktop: Hides the header logo when 10% of the footer logo is visible.
 * @param {HTMLElement} container - The main container that includes the header and footer.
 */
const initLogoVisibility = (container) => {
  const headerLogo = $Q('.header__logo', container) // Header logo element
  const footerLogo = $Q('.footer_logo', container) // Footer logo element

  if (!headerLogo || !footerLogo) return // Exit if either element is missing

  // Helper function to calculate if 10% of an element is visible
  const isTenPercentVisible = (element) => {
    const rect = element.getBoundingClientRect()
    const elementHeight = rect.height
    const visibleHeight = Math.max(
      0,
      Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top)
    )
    return (visibleHeight / elementHeight) >= 0.1
  }

  // Helper function to check overlap
  const isOverlapping = (rect1, rect2) => {
    return (
      rect1.bottom >= rect2.top &&
      rect1.top <= rect2.bottom &&
      rect1.right >= rect2.left &&
      rect1.left <= rect2.right
    )
  }

  // Function to check visibility based on scroll
  const checkLogoVisibility = () => {
    if (window.innerWidth <= 768) {
      // Mobile behavior: Check overlap
      const headerLogoPosition = headerLogo.getBoundingClientRect()
      const footerLogoPosition = footerLogo.getBoundingClientRect()

      if (isOverlapping(headerLogoPosition, footerLogoPosition)) {
        footerLogo.style.opacity = 0
        footerLogo.style.pointerEvents = 'none'
        footerLogo.style.transform = 'scale(0.6)' // Reduce size to 60%
      } else {
        footerLogo.style.opacity = 1
        footerLogo.style.pointerEvents = 'none'
        footerLogo.style.transform = 'scale(1)' // Reset to original size
      }
    } else {
      // Desktop behavior: Check 10% visibility
      if (isTenPercentVisible(footerLogo)) {
        headerLogo.style.opacity = 0
        headerLogo.style.pointerEvents = 'none'
      } else {
        headerLogo.style.opacity = 1
        headerLogo.style.pointerEvents = 'auto'
      }
    }
  }

  // Check visibility on scroll and resize
  window.addEventListener('scroll', checkLogoVisibility)
  window.addEventListener('resize', checkLogoVisibility)

  // Initial check
  checkLogoVisibility()
}

export default initLogoVisibility
